export default __webpack_public_path__ + "static/page-not-found-404-83fa60cb14446e07c5acd72a62965d7b.png";